import Vue from 'vue'
import App from './App.vue'
import router from './router'

const firebaseConfig = {
  apiKey: "AIzaSyCPPdZBdtzyVbCMfaB7fF8mq-ltHzzti2M",
  authDomain: "cristorey-apps.firebaseapp.com",
  databaseURL: "https://cristorey-apps-default-rtdb.firebaseio.com",
  projectId: "cristorey-apps",
  storageBucket: "cristorey-apps.appspot.com",
  messagingSenderId: "405308213681",
  appId: "1:405308213681:web:27245da50aea0104e05590"
};
firebase.initializeApp(firebaseConfig);

Vue.config.productionTip = false

Vue.prototype.$score = {}

new Vue({
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
